<template>
  <b-container>
    <b-row class="ja-decoration">
    </b-row>
    <b-form @submit.prevent="forgot()">
      <b-row>
        <b-col cols="12">
          <b-col cols="12" class="mt-1 title" tabindex="1">{{ $t("forgot_password_login") }}</b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12" class="mt-3">
            <label for="email" class="semi-bold purple-text">{{ $t("forgot_password_label_email") }}</label>
            <input id="email" type="text" v-model="form.email" value="" tabindex="2">
            <span v-if="emailError" class="form-error">{{ $t("error_required_field") }}</span>
            <ul class="error-content ">
              <li class="error-text" v-for="error in emailErrors" v-bind:key="error">
                {{ error }}
              </li>
            </ul>
          </b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12" class="mt-4">
            <b-button block variant="primary" type="submit" tabindex="3" :disabled="isDisabled">
              {{ $t("forgot_password_continue") }}
            </b-button>
          </b-col>
          <b-col cols="12" class="mt-2 mb-4">
            <b-button block variant="primary-inverse" v-on:keyup.enter.space="routeToHome"
                      v-on:click="routeToHome" tabindex="4">
              {{ $t("forgot_password_cancel") }}
            </b-button>
          </b-col>
        </b-col>
      </b-row>
    </b-form>
    <legal-message />
  </b-container>
</template>

<script>
import {UserService} from '../Services';
import LegalMessage from "../Components/LegalMessage"
import validateForms from '../../../core/Mixins/validate-forms'

export default {
  name: 'ForgotPassword',
  components: { LegalMessage },
  mixins: [validateForms],
  data() {
    return {
      form: {email: ""},
      emailError: false,
      emailErrors: [],
      serviceError: false,
      isDisabled: false,
    }
  },
  methods: {
    forgot() {
      const email = this.form.email;
      this.emailError = email === "";

      if(email && this.isValidform()){
        this.isDisabled = true;
        this.emailErrors = [];
        this.serviceError = false

        UserService.changePasswordRequest(email).then(() => {
          this.$router.push({name: 'VerifyEmailPassword' , params: { email }  });
        }).catch(err => {
          this.isDisabled = false;
          if (err) {
            if (err.message) {
              this.serviceError = err.message
            }
            if (err.errors && err.errors['Email']) {
              err.errors['Email'].forEach(error => this.emailErrors.push(this.$t(error)))
            }
          }
        })
      }
    },
    routeToHome(){
      this.$router.push({name: 'Login'})
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "../Styles/security_styles.styl"
</style>
